module.exports = __webpack_public_path__ + "img/model-4.18c172fa.png";